import { PureComponent } from 'react';

import { ConnectIframe } from '@atlassian/bitbucket-connect-react';

import { commitFileTarget, CommitFileTargetProps } from 'src/connect/targets';

import LoadingFailed from './loading-failed';

type FileViewerProps = CommitFileTargetProps & {
  height?: string;
  principalId: string;
  viewer?: string;
};

export class FileViewer extends PureComponent<FileViewerProps> {
  render() {
    const {
      hash,
      height,
      path,
      principalId,
      repositoryOwner,
      repositorySlug,
      viewer,
    } = this.props;

    return (
      <ConnectIframe
        defaultStyles={{ height, width: '100%' }}
        moduleType="fileViews"
        principalId={principalId}
        target={commitFileTarget({
          path,
          hash,
          repositoryOwner,
          repositorySlug,
        })}
        moduleKey={viewer}
        loadingFailedComponent={LoadingFailed}
      />
    );
  }
}
